import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/validate/validate-move.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { isNotEmpty } from '@gmini/utils';
import { getNode, getReferenceByNode } from "../../classifier-service";
import { isGroupType } from "../../classifier-service/adapters";
import { isReferenceNode, isUserClassifierGroupNode } from "../../classifier-service/Node";
import { isMaxNestingLevelFunc } from "./nesting-level";
export var validateMoveFromOwn = function validateMoveFromOwn(params) {
  var items = params.items,
      nodes = params.nodes,
      currClsData = params.currClsData,
      targetNode = params.targetNode;
  var moveDisabledByHasNoRefs = items.some(function (item) {
    var _referenceNode$source;

    var node = getNode(nodes, item);

    if (!node) {
      return null;
    }

    var targetHasFilterConditions = targetNode.type === 'UserClassifierGroupNode' && !!targetNode.filterCondition;

    if (targetHasFilterConditions || targetNode.type === 'UserClassifierNode' && isUserClassifierGroupNode(node) && node.parentGroupId) {
      return true;
    }

    if (isGroupType(item.type)) {
      var _node$source;

      if (isUserClassifierGroupNode(node) && ((_node$source = node.source) === null || _node$source === void 0 ? void 0 : _node$source.relationType) === 'Indirect') {
        return true;
      }

      return false;
    }

    var referenceNode = isReferenceNode(node) ? node : getReferenceByNode(nodes, _objectSpread(_objectSpread({}, item), {}, {
      classifierId: currClsData.id,
      classifierVersion: currClsData.version
    })); // Если в текущем классификаторе нет рефа данной ноды - значит выбрана Bim-нода

    if (!referenceNode) {
      return true;
    } //  Если выбран реф перенесенный в составе группы


    if (((_referenceNode$source = referenceNode.source) === null || _referenceNode$source === void 0 ? void 0 : _referenceNode$source.relationType) === 'Indirect') {
      return true;
    }

    return false;
  });

  if (moveDisabledByHasNoRefs) {
    return 'Нельзя переносить элементы из перенесенной иерархии';
  }

  var groupNodes = items.map(function (ref) {
    return getNode(nodes, ref);
  }).filter(isNotEmpty).filter(isUserClassifierGroupNode);

  if (targetNode.type === 'UserClassifierGroupNode' && groupNodes.some(function (gr) {
    return !gr.parentGroupId;
  })) {
    return 'Нельзя переносить рутовые папки';
  }

  var checkedHasFilteredItems = items.some(function (item) {
    if (item.type === 'UserClassifierEmptyGroupNode' || item.type === 'UserClassifierGroupWithGroupsNode' || item.type === 'UserClassifierNode' || item.type === 'UserClassifierGroupWithElementsNode') {
      var node = getNode(nodes, item);
      return !!(node !== null && node !== void 0 && node.filterCondition);
    }

    if (item.type === 'BimElementReferenceNode' || item.type === 'BimElementNode') {
      var _node2 = getNode(nodes, item);

      var parentGroup = getNode(nodes, {
        type: 'UserClassifierGroupNode',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        id: _node2 === null || _node2 === void 0 ? void 0 : _node2.parentGroupId
      });
      return parentGroup === null || parentGroup === void 0 ? void 0 : parentGroup.filterCondition;
    }
  });

  if (checkedHasFilteredItems) {
    return 'Нельзя перемещать папки с настроенным фильтром';
  }

  return validateCommonMove(params);
};
export var validateMoveFromDeps = function validateMoveFromDeps(params) {
  if (params.targetNode.filterCondition) {
    return 'Нельзя вставить элементы в папку с настроенным фильтром';
  }

  if (!params.items.length) {
    return 'Список выделенных элементов пуст';
  }

  var insertDisabledByEmptyGroups = params.items.some(function (item) {
    return item.type === 'UserClassifierEmptyGroupNode';
  });

  if (insertDisabledByEmptyGroups) {
    return 'Нельзя вставлять пустые папки из других классификаторов';
  }

  if (params.dynamicMode) {
    return 'Нельзя переносить элементы в режиме группировок';
  }

  return validateCommonMove(params);
};

var validateCommonMove = function validateCommonMove(_ref) {
  var items = _ref.items,
      nodes = _ref.nodes,
      targetNode = _ref.targetNode,
      nestingLevel = _ref.nestingLevel;
  var isMaxNestingLevel = isMaxNestingLevelFunc(nestingLevel);
  var checkedHasTarget = items.some(function (item) {
    return isGroupType(item.type) && item.id === (targetNode === null || targetNode === void 0 ? void 0 : targetNode.id);
  });
  var checkedHasGroups = items.some(function (item) {
    return isGroupType(item.type) || item.type === 'DynamicGeneratedGroupNode';
  });
  var checkedHasElements = items.some(function (item) {
    return !isGroupType(item.type) && item.type !== 'DynamicGeneratedGroupNode';
  });
  var moveValidateError = validateContent({
    targetNode: targetNode,
    checkedItems: items,
    nodes: nodes
  });

  if (moveValidateError) {
    return moveValidateError;
  }

  if (checkedHasTarget) {
    return 'Нельзя перемещать элемент внутрь самого элемента';
  } else if ((targetNode === null || targetNode === void 0 ? void 0 : targetNode.type) === 'UserClassifierGroupNode' && targetNode.groupType === 'WithElements' && checkedHasGroups) {
    return 'Нельзя перемещать папки в папку с элементами';
  } else if ((targetNode === null || targetNode === void 0 ? void 0 : targetNode.type) === 'UserClassifierGroupNode' && targetNode.groupType === 'Empty' && checkedHasElements && checkedHasGroups) {
    return 'В пустую папку можно переносить или папки или элементы';
  } else if ((targetNode === null || targetNode === void 0 ? void 0 : targetNode.type) === 'UserClassifierNode' && checkedHasElements) {
    return 'Нельзя перемещать элементы в корень';
  } else if ((targetNode === null || targetNode === void 0 ? void 0 : targetNode.type) === 'UserClassifierGroupNode' && targetNode.groupType === 'WithGroups' && checkedHasElements) {
    return 'Нельзя перемещать элементы в папку с папками';
  } else if (isMaxNestingLevel && checkedHasGroups) {
    return 'Нельзя перемещать папки в папку т.к. она имеет максимальный уровень вложенности - 6';
  }

  return null;
};

var validateContent = function validateContent(_ref2) {
  var targetNode = _ref2.targetNode,
      checkedItems = _ref2.checkedItems,
      nodes = _ref2.nodes;

  if ('source' in targetNode && targetNode.source) {
    return 'Вы не можете добавить элементы в папку перенесенную из пользовательского классификатора';
  }

  if (checkDuplicates(checkedItems)) {
    return 'Нельзя добавлять одинаковые элементы в одну папку';
  }

  var checkedHasBim = checkedItems.some(function (_ref3) {
    var type = _ref3.type;
    return !isGroupType(type) && type !== 'DynamicGeneratedGroupNode';
  }); // Если какой-то из выбранных элементов уже есть в группе/корне классификатора - запрещаем перенос

  if (checkedItems.some(function (checkedItem) {
    var checkedNode = getNode(nodes, checkedItem);

    if (checkedNode && 'parentGroupId' in checkedNode) {
      if (!checkedNode.parentGroupId && targetNode.type === 'UserClassifierNode') {
        return checkedNode.parentClassifierId === targetNode.id;
      }

      return checkedNode.parentGroupId === targetNode.id;
    }
  })) {
    return 'Один из выбранных элементов уже находится в этой папке/корне классификатора';
  }

  if (checkedHasBim) {
    switch (targetNode.type) {
      case 'UserClassifierNode':
        return 'В корне можно создавать или переносить только папки из других классификаторов';

      case 'UserClassifierGroupNode':
        if (targetNode.groupType === 'WithGroups') {
          return 'В папку с папками можно добавлять только папки';
        }

    }
  } else if (targetNode.type === 'UserClassifierGroupNode') {
    if (targetNode.groupType === 'WithElements') {
      return 'В папку с элементами модели можно добавлять только элементы модели';
    }
  }

  var sameName = checkedItems.some(function (item) {
    var _node = getNode(nodes, item);

    var node = _node && isReferenceNode(_node) ? getNode(nodes, _node.element) : _node;
    return node ? hasSameNameChild(targetNode, node, nodes) : false;
  });

  if (sameName) {
    return 'Папка уже содержит такой элемент';
  }

  return null;
};

export function checkDuplicates(checkedItems) {
  return checkedItems.some(function (checkedItem, i, arr) {
    return arr.filter(function (checked) {
      return checked.id === checkedItem.id && checked.parentClassifierId === checkedItem.parentClassifierId;
    }).length > 1;
  });
}
export function isRootGroup(node) {
  return !!node && isUserClassifierGroupNode(node) && node.parentGroupId == null;
}
export function hasSameNameChild(targetNode, node, nodes) {
  if (targetNode.type === 'UserClassifierNode' && targetNode.children) {
    var hasSameName = targetNode.children.map(function (n) {
      return getNode(nodes, n);
    }).some(function (n) {
      return 'name' in node ? (n === null || n === void 0 ? void 0 : n.name) === node.name : false;
    });
    return hasSameName;
  }

  if (targetNode.type === 'UserClassifierGroupNode' && targetNode.groupType !== 'Empty') {
    var hasChildWithSameName = targetNode.groupType === 'WithElements' ? targetNode.children.map(function (ref) {
      return getNode(nodes, ref);
    }).filter(isNotEmpty).map(function (ref) {
      return getNode(nodes, ref.element);
    }).some(function (child) {
      return (child === null || child === void 0 ? void 0 : child.type) === node.type && child.id === node.id;
    }) : targetNode.children.map(function (ref) {
      return getNode(nodes, ref);
    }).some(function (child) {
      return (child === null || child === void 0 ? void 0 : child.type) === node.type && child.id === node.id;
    });
    return hasChildWithSameName;
  }

  return false;
}